import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import {
    gridNumberFormatter,
    gridUTCDateFormatter,
    formattedNumberValueGetter,
    csvDateHeaderValueGetter,
    formattedUTCDateValueGetter,
} from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, keyColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { MONTH_REPORT_ID } from './monthReportId';

const monthReportColumnDefinition = [
    {
        headerName: FIELDS.DATE.label,
        headerValueGetter: FIELDS.DATE.headerValueGetter,
        headerComponentParams: FIELDS.DATE.headerComponentParams,
        field: FIELDS.DATE.field,
        type: [leftPinnedColumn, keyColumn],
        valueFormatter: gridUTCDateFormatter,
        maxWidth: 180,
        csvValueGetter: formattedUTCDateValueGetter,
        csvHeaderValueGetter: csvDateHeaderValueGetter,
    },
    ...[
        FIELDS.IMPRESSIONS,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.VCPM,
        FIELDS.VCTR,
        FIELDS.CLICKS,
        FIELDS.AVERAGE_CPC,
        FIELDS.CVR,
        FIELDS.CVR_CLICKS,
        FIELDS.CVR_VIEWS,
        FIELDS.CONVERSIONS,
        FIELDS.CONVERSIONS_CLICKS,
        FIELDS.CONVERSIONS_VIEWS,
        FIELDS.CPA,
        FIELDS.CPA_CLICKS,
        FIELDS.CPA_VIEWS,
        FIELDS.SPENT,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
        FIELDS.ROAS_CLICKS,
        FIELDS.ROAS_VIEWS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(monthReportColumnDefinition, MONTH_REPORT_ID);
